import { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";

const useUserActivity = () => {
  const lastActivityRef = useRef(Date.now());
  const location = useLocation();

  // Check if current page is an admin page
  const isAdminPage = location.pathname.startsWith("/admin");

  const updateActivity = useCallback(() => {
    lastActivityRef.current = Date.now();
    // Store activity timestamp in localStorage for cross-tab sync
    if (isAdminPage) {
      localStorage.setItem(
        "lastUserActivity",
        lastActivityRef.current.toString(),
      );
    }
  }, [isAdminPage]);

  const getLastActivity = useCallback(() => {
    // Get the most recent activity from either memory or localStorage
    const storedActivity = localStorage.getItem("lastUserActivity");
    const storedTime = storedActivity ? parseInt(storedActivity) : 0;
    return Math.max(lastActivityRef.current, storedTime);
  }, []);

  const isUserActive = useCallback(
    (thresholdMinutes = 5) => {
      const now = Date.now();
      const lastActivity = getLastActivity();
      const timeDiff = now - lastActivity;
      const minutesDiff = timeDiff / (1000 * 60);

      return minutesDiff < thresholdMinutes;
    },
    [getLastActivity],
  );

  useEffect(() => {
    if (!isAdminPage) return;

    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
      "click",
      "keydown",
    ];

    const throttledUpdateActivity = (() => {
      let timeout;
      return () => {
        if (timeout) return;
        timeout = setTimeout(() => {
          updateActivity();
          timeout = null;
        }, 1000); // Throttle to once per second
      };
    })();

    // Add event listeners
    events.forEach((event) => {
      document.addEventListener(event, throttledUpdateActivity, true);
    });

    // Initialize activity on mount
    updateActivity();

    // Cleanup
    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, throttledUpdateActivity, true);
      });
    };
  }, [isAdminPage, updateActivity]);

  console.log("isAdminPage", isAdminPage, isUserActive());

  return {
    isUserActive,
    getLastActivity,
    updateActivity,
    isAdminPage,
  };
};

export default useUserActivity;
